module.exports = __webpack_public_path__ + "static/img/boxImg3.f4d7c1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/boxImg3.png
// module id = OdyA
// module chunks = 2